import {
  WorkflowDataResolverDependencies,
  WorkflowDefaultStepContentBlock,
  WorkflowDefaultStepContentBlockHeadingObject,
} from '~/core/shared/types';
import {
  isEvaluatable,
  resolveEvaluatable,
} from '~/core/shared/utils/evaluatable';

export const evaluateHeading = (
  heading: WorkflowDefaultStepContentBlock['heading'],
  workflowDataResolverDependencies: WorkflowDataResolverDependencies,
) => {
  if (heading) {
    if (isEvaluatable(heading)) {
      return resolveEvaluatable(heading, workflowDataResolverDependencies);
    }
    if (typeof heading !== 'string' && isEvaluatable(heading.text)) {
      return {
        ...heading,
        text: resolveEvaluatable(
          heading.text,
          workflowDataResolverDependencies,
        ),
      };
    }
    return heading as string | WorkflowDefaultStepContentBlockHeadingObject;
  }

  return undefined;
};
